import { CSSProperties } from 'react';
import unauthBackgroundUri from '../../../assets/unauth-background.jpeg';

type StylesKeys = 'background';

const styles: Record<StylesKeys, CSSProperties> = {
  background: {
    backgroundImage: `url(${unauthBackgroundUri})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'top right',
    transform: 'scaleX(-1)',
  },
};

function UnauthBackground() {
  return (
    <div
      className="h-full w-full absolute top-0 left-0 -z-10"
      style={styles.background}
    >
      <div className="h-full w-full bg-slate-900 bg-opacity-50"></div>
    </div>
  );
}

export default UnauthBackground;
